$(document).ready(function () {
  const isDebug = false;
  const baseStyles = [
    "color: #fff",
    "background-color: #2759e1",
    "padding: 2px 8px",
    "border-radius: 4px",
  ].join(";");
  function consoleLog() {
    if (window.console && isDebug === true) {
      console.log(
        "%cNP-ss-v1",
        baseStyles,
        ...Array.prototype.slice.call(arguments)
      );
    }
  }

  /**
   * Removes the iCart element
   */
  const removeICart = () => {
    $("body > .icart").remove();
  };

  let currentQuantities = {};
  let currentPack = 2;
  const showSubscriptions = window.sipnsniffSettings.showSubscriptions || false;

  $(".lp-ss--learn-more-btn").click(function () {
    $(".lp-ss--scroll-to-learn").fadeIn("slow");

    const sectionHeight = $(".lp-ss--why-kids-love-np-section").outerHeight();

    const sectionOffsetTop = $(".lp-ss--why-kids-love-np-section").offset().top;

    $(window).scroll(function () {
      let scrollTopj = $(window).scrollTop();
      let scrollPoint = sectionOffsetTop + sectionHeight;

      console.log(
        "ScrollTop:",
        Math.floor(scrollTopj),
        "ScrollPoint:",
        Math.floor(scrollPoint)
      );

      if (scrollTopj >= scrollPoint) {
        $(".lp-ss--scroll-to-learn").fadeOut("fast");
      }
    });
  });

  // listener to toggle StayAI
  $('[for="purchaseTypeSubscription"]').on("click", function () {
    updateOffer(true);
  });
  $('[for="purchaseTypeOneTime"]').on("click", function () {
    updateOffer(false);
  });

  function choosePack(packQty) {
    consoleLog("choosePack", packQty);
    const packsContainer = $("#selectPacks-box");
    currentPack = packQty;

    packsContainer.find(".packs.selected").removeClass("selected");
    packsContainer.find(`.packs[data-pack="${packQty}"]`).addClass("selected");
  }

  const packs = $("#selectPacks-box .packs");

  const updatePacksPricing = (hasSubscription) => {
    packs.each(function () {
      const pack = $(this);
      consoleLog(pack);
      const currencyRate = Shopify.currency.rate;
      const packQty = pack.attr("data-pack");

      const subscriptionPrice = Shopify.formatMoney(
        pack.attr("data-pack-subscription-price") * currencyRate
      );
      const packPrice = Shopify.formatMoney(
        pack.attr("data-pack-sale-price") * currencyRate
      );
      const pricePerEach = Shopify.formatMoney(
        pack.attr("data-price-per-each") * currencyRate
      );
      const subscriptionPricePerEach = Shopify.formatMoney(
        pack.attr("data-subscription-price-per-each") * currencyRate
      );

      const elPackPrice = pack.find(".pack-price");
      const elPricePerEach = pack.find(".price-per-each");

      if (showSubscriptions === true && hasSubscription) {
        elPackPrice.text(subscriptionPrice);
        elPricePerEach.text(subscriptionPricePerEach);
      } else {
        elPackPrice.text(packPrice);
        elPricePerEach.text(pricePerEach);
      }
    });
  };

  packs.each(function () {
    const pack = $(this);
    pack.on("click", () => {
      choosePack(pack.attr("data-pack"));
    });
  });

  /**
   * Updates the offer text based on the selected pack.
   *
   * @param {HTMLElement} listPack - The list pack element.
   */
  const updateOffer = (hasSubscription) => {
    consoleLog("updateOffer");
    if (showSubscriptions === false) return;

    updatePacksPricing(hasSubscription);
  };

  updatePacksPricing();
  choosePack(2);
  updateOffer(true);

  const setFlavorQty = (flavorEl, variantId, quantity) => {
    consoleLog("setFlavorQty", flavorEl, variantId, quantity);
    const currentQty = currentQuantities[variantId] || 0;

    // hide qty adjustment if we are down to just 1 pack
    if (quantity < 1) {
      flavorEl.find(".lp-ss--adjust-qty").addClass("hidden");
      flavorEl.find(".lp-ss--add-btn").removeClass("hidden");
    }

    // show qty adjustment if we are first adding a pack
    if (quantity >= 1 && currentQty < 1) {
      flavorEl.find(".lp-ss--adjust-qty").removeClass("hidden");
      flavorEl.find(".lp-ss--add-btn").addClass("hidden");
    }

    currentQuantities[variantId] = quantity;
    flavorEl.find(".lp-ss--qty").text(`${quantity}`);
  };

  $(".lp-ss--flavor-lists li").each(function () {
    const flavorEl = $(this);
    const variantId = $(this).attr("data-flavor-id");

    $(this)
      .find(".lp-ss--more-btn")
      .on("click", function () {
        let packQty = currentQuantities[variantId] || 0;
        packQty++;
        setFlavorQty(flavorEl, variantId, packQty);
      });

    $(this)
      .find(".lp-ss--less-btn")
      .on("click", function () {
        let packQty = currentQuantities[variantId] || 0;
        packQty--;
        setFlavorQty(flavorEl, variantId, packQty);
      });
  });

  $(this)
    .find(".lp-ss--add-btn")
    .on("click", function () {
      const flavorEl = $(this).closest(".lp-ss--flavor-lists li");
      const variantId = flavorEl.attr("data-flavor-id");
      setFlavorQty(flavorEl, variantId, 1);
    });
  // SELECT FLAVOUR
  $(".lp-ss--select-flavor").on("click", function (e) {
    e.preventDefault();
    $("#selectPacks-box").hide();
    $("#selectFlavour-box").show();
  });

  // Back to packs
  $(".lp-ss--arrow-back-btn").on("click", function (e) {
    $("#selectPacks-box").show();
    $("#selectFlavour-box").hide();
  });

  $(".lp-ss--quantity-box").hide();

  function letFBKnow() {
    const product = window.product;

    fbq_data = {
      content_name: product.title,
      content_ids: product.id,
      content_type: "product_group",
      value: currentPrice.value,
      currency: product.currency,
    };
    consoleLog(["fbq_data", fbq_data]);

    if (fbq) {
      fbq("track", "AddToCart", fbq_data);
      fbq("track", "InitiateCheckout", fbq_data);
    }
  }

  /**
   * Adds an item to the cart.
   *
   * @param {string} variantQtys - The Shopify ID of the variant to add to the cart + qty
   * @param {number} sellingPlan - The StayAI selling plan ID (optional).
   * @returns {boolean} - Returns false.
   */
  const formATC = (variantQtys, sellingPlan) => {
    consoleLog(["formATC", variantQtys, sellingPlan]);

    if (variantQtys.length === 0) {
      return;
    }

    const data = {
      items: [],
      sections: "cart-notification-product,cart-notification-button,cart-icon-bubble",
      sections_url: window.location.pathname,
    };

    for (const [variantId, qty] of Object.entries(variantQtys)) {
      if (qty < 1) {
        continue;
      }

      const variantData = {
        id: variantId,
        quantity: qty,
      };

      if (sellingPlan > 0) {
        variantData["selling_plan"] = sellingPlan;
      }

      data.items.push(variantData);
    }
    consoleLog(["data", data]);

    if (window.sipnsniffSettings.redirectToCheckout === true) {
      removeICart();
    }
    // letFBKnow();

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (xhr, status) {
        consoleLog("Sucessful cart add!", xhr, status);

        setTimeout(function () {
          consoleLog("Trying to get to checkout");
          document
            .querySelector("#selectFlavour-box .package_button")
            .classList.remove("processing");

          if (window.sipnsniffSettings.redirectToCheckout === true) {
            window.location.href = "/checkout?skipCache";
          } else {
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            
            if (cart) {
              consoleLog('Adding to cart…');
              cart.classList.add('cart-notifications--product-flavors');

              // formData.append(
              //   'sections',
              //   cart.getSectionsToRender().map((section) => section.id)
              // );
              // formData.append('sections_url', window.location.pathname);
              // cart.setActiveElement(document.activeElement);

              // for (const [sectionId, sectionHTML] of Object.entries(xhr.sections)) {
              //   document.getElementById(sectionId).innerHTML = sectionHTML;
              // }

              let first = true;
              xhr.items.forEach((item) => {
                if (first) {
                  // do this to get the other sections
                  cart.renderContents({
                    ...item,
                    sections: xhr.sections,
                    sections_url: window.location.pathname,
                  });
                  first = false;
                  $('#cart-notification-product')[0].innerHTML = "";
                }
                $('#cart-notification-product').append(
                  new DOMParser().parseFromString(xhr.sections['cart-notification-product'], 'text/html').querySelector(`[id="cart-notification-product-${item.key}"]`).outerHTML
                );
              });
              cart.open();
            }
          }
        }, 1000);
        return false;
      },
      error: function (xhr, status, error) {
        consoleLog("Error adding to the cart:");
        consoleLog(xhr.responseText);
        consoleLog(status);
      },
    });
  };

  $("#proceed").on("click", function (e) {
    e.preventDefault();
    $(this).addClass("processing");
    let sellingPlan = 0;
    
    if ($('.is-selected[for="purchaseTypeSubscription"]').length === 1) {
      sellingPlan = $('.rtx-subscription-dropdown').val();
    }
    consoleLog('sellingPlan', sellingPlan);

    formATC(currentQuantities, sellingPlan);
  });
});
